export enum MetaDataTypes {
  INVOICE = "invoice"
}
